import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.625 11.167 12 7m0 0 4.375 4.167M12 7v10"
    />
  </svg>
);
export default SvgArrowUpSm;
